import axios from "axios"



//创建axios实例
const instance = axios.create({
	//默认前缀
	baseURL: process.env.VUE_APP_BASE_URL,
	timeout: 200000 //请求超时时间
})


//请求拦截器,设置token
instance.interceptors.request.use(request => {
	return request
}, error => {
	return Promise.reject(error)
})

//响应拦截器
instance.interceptors.response.use(response => {
	
	// console.log('response',response)
	
	const status = response.status
	const data = response.data
	// const msg = response.data.msg

	if (status === 200 && data) {
		return data
	}
}, error => {

	
	return Promise.reject(error)
})

export default instance